const simpleCardStyle = theme => ({
  simpleCard: {
    height: `calc(100% - ${theme.spacing(7)}px)`,
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    minHeight: 165 - theme.spacing(2),
  },
  iconContainer: {
    width: theme.spacing(7),
    minWidth: theme.spacing(7),
    height: theme.spacing(7),
    overflow: 'hidden',
    borderRadius: '100%',
    border: '1px solid ' + theme.palette.divider,
    fontSize: '20px',
    marginRight: '20px',
    position: 'absolute',
    top: 0,
    left: theme.spacing(2),
    // background: 'red',
    background: theme.palette.background.paper,
    transform: 'translateY(-50%)',
    boxShadow: '0px 10px 30px rgba(169, 173, 194, 0.15)',
  },

  withIcon: {
    marginTop: theme.spacing(3.5),
    overflow: 'unset',
    // marginBottom: theme.spacing(2),
    // height: 'calc(100% - ' + theme.spacing(5.5) + 'px)',
  },
  smallIcon: {
    fontSize: '20px',
    color: theme.variables.colors.icon,
  },
  titleMargin: {
    marginTop: theme.spacing(3),
  },
  title: {},
  titleHeight: {
    minHeight: theme.spacing(4),
  },
  simpleValue: {},
  cardActive: {
    backgroundColor: theme.palette.primary.main,
    '& $simpleValue': { color: theme.palette.primary.contrastText },
    '& $title': { color: theme.palette.primary.contrastText },
  },
  minHeightOff: {
    height: 'unset',
    minHeight: 'unset',
  },
  minHeight: {
    minHeight: '100%',
  },
  modal: {
    minHeight: 200 - theme.spacing(2),
  }
})

export default simpleCardStyle
